import { ReactNode, useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

type SectionBoxProps = {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
};

const SectionBox = ({ title, icon, children }: SectionBoxProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-white rounded-3xl">
      <div className="flex items-center px-3">
        <div className="flex flex-row items-center gap-2">
          {icon}
          <span>{title}</span>
        </div>
        <button className="ml-auto p-2" onClick={() => setOpen(!open)}>
          {open ? (
            <ChevronUpIcon className="w-8 h-8" />
          ) : (
            <ChevronDownIcon className="w-8 h-8" />
          )}
        </button>
      </div>
      {open && <div className="px-4 pb-2 text-sm">{children}</div>}
    </div>
  );
};

export default SectionBox;
